import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { environmenAchievement } from '../../../environments/enviroment.achievement';
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressSpinnerModule, ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { interval, Subscription, takeUntil, timer } from 'rxjs';
import { AchievementService } from './achievement-service';
import { AllStatus } from '../../core/services/status/all-status';
import { RaitingSystem } from '../../shared/services/ratings/raiting-system';
import { result } from 'lodash';
import { TranslatePipe } from '@ngx-translate/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-achievement',
  imports: [MatTooltip, MatProgressSpinnerModule, TranslatePipe, MatProgressBarModule],
  templateUrl: './achievement.html',
  styleUrl: './achievement.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Achievement implements OnInit, OnDestroy {
  readonly lists = environmenAchievement;
  mode: ProgressSpinnerMode = 'determinate';
  achievementService = inject(AchievementService);
  allStatus = inject(AllStatus);
  raiting = inject(RaitingSystem);

  subCart: Subscription;
  timerSubscription: Subscription;
  finalResult: Subscription;
  isChampion: Subscription;
  subscriptionDW: Subscription;

  hide = signal(false);

  summPoints: number = 0;

  constructor( private ref: ChangeDetectorRef){}

  ngOnDestroy(): void {
    if(this.subCart){
      this.subCart.unsubscribe();
    }
    if(this.timerSubscription){
      this.timerSubscription.unsubscribe();
    }
    if(this.finalResult){
      this.finalResult.unsubscribe();
    }
    if(this.isChampion){
      this.isChampion.unsubscribe();
    }
    if(this.subscriptionDW){
      this.subscriptionDW.unsubscribe();
    }
  }
  
  ngOnInit(): void {
    this.summPoints = 0;
    this.achievementService.init(this.allStatus.currentLevel());

    this.runHardy();

    this.subCart = this.allStatus.nowCard.subscribe((card: any)=>{
      if(card){
        let result = this.raiting.successesInGame(card);
        if(result.points > 0){
          this.summPoints = this.summPoints + result.points;
        }
        let res: number = (result.points / result.maxPoints) * 100;
        this.runStable(parseFloat(res.toFixed(2)), result.points);
      }
    });

   this.finalResult = this.allStatus.finalResult.subscribe((result: number)=>{
      if(result > 0){
        this.runMaster(result, this.allStatus.playerPointsLevel());
      }
    });

    this.isChampion = this.achievementService.eventChanpion.subscribe( (result:boolean)=>{
      if(result){
        this.ref.markForCheck();
      }
    });

    this.subscriptionDW = this.allStatus.downTime$.subscribe((follow: any)=>{
      if(follow){
        this.ngOnDestroy();
      }
    });
  }

  runHardy(){
    const tm = this.lists.hardy.account * 1000;
    this.timerSubscription = timer(0, tm).subscribe(n => {
      if(n > 0){
        this.achievementService.fnInitHardy(this.summPoints);
      }
      this.ref.markForCheck(); 
    });
  }

  runStable(maxPointer: number, points: number){
    this.achievementService.fnInitStable(maxPointer, points);
    this.ref.markForCheck(); 
  }

  runMaster(finResult: number, points: number){
    this.achievementService.fnInitMaster(finResult, points);
    this.ref.markForCheck();
  }
  
  countAchievement(): number{
    let current:number = this.lists.stable.count + this.lists.hardy.count + this.lists.master.count + this.lists.champion.count;
    return current;
  }

  blockState(event: MouseEvent){
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

}
